import { IContentSource } from "../../../domain/drawing";

export class FixedPhraseExportSource implements IContentSource {
  constructor(private _getToken: () => string, private filePath: string) {
  }

  get token(): string {
    return this._getToken();
  }

  get source(): string {
    return "/api/templatephrase/download-export-file?token=" + this.token + "&filePath=" + encodeURIComponent(this.filePath);
  }

  clone(): FixedPhraseExportSource {
    return new FixedPhraseExportSource(this._getToken, this.filePath);
  }
}
